// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";
import { profileHrColor, reset } from "../../utils/commonJssConstants";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const sidePadding = "36px";
const containerWidth = "470px";
const checkBoxSize = "22px";

export const ProfileManageDataPageStyles = (config: DesignSystem) => ({
    profileManageDataPageContainer: {
        ...reset,
        "box-sizing": "content-box !important",
        display: "flex !important",
        "flex-direction": "column",
        "justify-content": "space-between",
        "align-items": "center",
        width: `calc( ${containerWidth} - (${sidePadding} * 2))`,
        "max-width": `calc( 100% - (${sidePadding} * 2))`,
        margin: "0 auto",
        padding: "34px " + sidePadding,
        "min-height": `calc( ${containerWidth} - (34px * 2))`,
        background: neutralLayerCard,

        "& .cwt-h-seperator": {
            height: "1px",
            margin: `0 -${sidePadding}`,
            background: profileHrColor,
            border: "none"
        },

        "& .cwt-sub-text": {
            "font-weight": "normal",
            "font-size": "13px",
            "line-height": "18px",
            color: neutralForegroundHint
        },

        "& .cwt-header": {
            display: "flex",
            "flex-direction": "column",
            "align-items": "center",
            "margin-bottom": "16px",

            "& .cwt-title": {
                margin: "16px 16px 8px",
                "font-weight": "600",
                "font-size": "24px"
            }
        },

        "& div.cwt-buttons": {
            display: "flex",
            "flex-wrap": "wrap",
            "justify-content": "center",
            margin: "20px 0 0",

            "& .cwt-fast-button": {
                "min-width": "130px",
                "margin-bottom": "5px",
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "9px"
            }
        },

        "& .cwt-checklist": {
            margin: "16px 0 14px",
            padding: "0",

            "& .cwt-checklist-item": {
                display: "flex",
                "align-items": "center",
                margin: "0 0 14px",

                "& .cwt-checkbox": {
                    "min-width": checkBoxSize,
                    "min-height": checkBoxSize,
                    margin: "0",
                    padding: "4px",
                    background: neutralLayerCard,
                    border: "1px solid #DDDDDD",
                    "border-radius": "2px",

                    "& .cwt-icon": {
                        "font-size": checkBoxSize,
                        color: neutralForegroundHint
                    }
                },

                "& div.cwt-checklist-item-content": {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                    margin: "0 16px",

                    "& .cwt-label": {
                        margin: "0",
                        padding: "0",
                        "font-size": "15px",
                        "font-weight": "600",
                        "line-height": "20px",
                        color: neutralForegroundRest
                    },

                    "& .cwt-sub-text": {
                        margin: "0",
                        padding: "0"
                    }
                }
            }
        }
    }
});